// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "td[data-v-6bbfa8fc]{padding-top:3rem}.amount-adjust-width[data-v-6bbfa8fc]{max-width:160px}@media only screen and (max-width:768px){.amount-adjust-width[data-v-6bbfa8fc]{max-width:130px}}.cart-row[data-v-6bbfa8fc]{transition:background-color .3s ease-in-out}.highlight-preorder .cart-items .cart-row.preorder-item td[data-v-6bbfa8fc]{--bg-opacity:1;background-color:#f7fafc;background-color:rgba(247,250,252,var(--bg-opacity))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
